module.exports = __webpack_public_path__ + "img/xg.c69d0fa3.png";